module.exports = __webpack_public_path__ + "static/media/quick-view-by-secomapp.6f7cfaa7.png";